<!-- Mobile Waage-->
<div *ngIf="auftrag && auftragsposition && isMobileWaageVerwenden">
  <ng-container *ngFor="let wiegung of auftragsposition.Wiegungen2">
    <!-- Normale Wiegung oder Leergewicht -->
    <!-- <ion-item lines="none" *ngIf="wiegung.Typ !== 2">
      <ion-label position="stacked">{{ wiegung.Bezeichnung }}</ion-label>
      <div class="wiegung-ausgabe" *ngIf="wiegung.Text">
        {{ wiegung.Text }}
      </div>
    </ion-item> -->

    <!-- Handeingabe -->
    <!-- <ion-item lines="none" *ngIf="wiegung.Typ === 2">
      <ion-label position="stacked">{{ wiegung.Bezeichnung }}</ion-label>
      <ion-input
                 inputmode="numeric"
                 type="text"
                 (ionChange)="onGewichtChanged(wiegung)"
                 [(ngModel)]="wiegung.Gewicht"
                 id="wiegung-{{ auftragsposition.PosNr }}-{{ wiegung.Nummer }}-input"
                 (keyup.enter)="app.closeKeyboard($event)" enterkeyhint="done"
                 clearInput required></ion-input>
    </ion-item> -->

    <!-- <ion-item lines="none" *ngIf="wiegung.Typ === 3">
      <ion-label position="stacked">Einheit</ion-label>
      <ion-select placeholder="{{ 'Bitte Einheit auswählen' | translate }}" [(ngModel)]="wiegung.Einheit" (ngModelChange)="onGewichtChanged(wiegung)" interface="popover" required [okText]="'OK' | translate" [cancelText]="'Abbrechen' | translate">
        <ion-select-option *ngFor="let a of einheiten" [value]="a">{{ a }}</ion-select-option>
      </ion-select>
    </ion-item> -->

  </ng-container>


  <div *ngIf="!auftragdetails.isLieferungAendernGesperrt">
    <!-- Erstwiegung -->
    <ion-button size="large" class="auftragsposition-wiegen-button" color="light" appClick (clicked)="onWiegen(1)">
      <ion-icon *ngIf="isErstwiegungErfolgreich" slot="start" icon="checkmark" class="icon-checkmark"></ion-icon>
      Erstwiegung
    </ion-button>

    <!-- Zweitwiegung -->
    <ion-button size="large" class="auftragsposition-wiegen-button" color="light" appClick (clicked)="onWiegen(2)" [disabled]="!isErstwiegungErfolgreich">
      <ion-icon *ngIf="isZweitwiegungErfolgreich" slot="start" icon="checkmark" class="icon-checkmark"></ion-icon>
      Zweitwiegung
    </ion-button>
  </div>

  <!-- Offene Wiegungen zuordnen (z.B. über die Handtaster am Fahrzeug durchgeführt) -->
  <div *ngIf="isWiegungZuordnenErlaubt && !auftragdetails.isLieferungAendernGesperrt" class="wiegung-zuordnen-section">
    <ion-button expand="block" size="default" color="light" appClick (clicked)="onWiegungenZuordnen()" [disabled]="!offeneWiegungen.length">
      Wiegung zuordnen
      <ion-badge *ngIf="offeneWiegungen.length" color="danger" slot="end">{{ offeneWiegungen.length }}</ion-badge>
    </ion-button>

    <div *ngIf="!offeneWiegungen.length" class="keine-offenen-wiegungen">Keine offenen Wiegungen</div>
  </div>

  <!-- Wiegungen -->
  <ion-list *ngIf="auftragsposition.Wiegungen && auftragsposition.Wiegungen.length">
    <ion-list-header>
      <ion-label>Wiegungen</ion-label>
    </ion-list-header>

    <ion-item *ngFor="let w of auftragsposition.Wiegungen" class="no-padding-end">
      <ion-label>{{ w.Wiegenummer }}, Net: {{ w.Netto }} kg, W1: {{ w.Wiegung1 }} kg, W2: {{ w.Wiegung2 }} kg</ion-label>
      <ion-button slot="end" fill="clear" class="delete-item-button" appClick (clicked)="onWiegungEntfernen(w)" color="danger">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-item>
  </ion-list>

  <div *ngIf="auftragsposition.NettoGewicht" class="netto-gewicht">Netto: <span class="netto-gewicht-span" [class.ungueltig]="auftragsposition.NettoGewicht < 0">{{ auftragsposition.NettoGewicht }}</span> {{ auftragsposition.Wiegungen2[0].Einheit }}</div>
</div>

<!-- Wiegen mit stationären Remote-Waagen-->
<div *ngIf="auftrag && auftragsposition && !isMobileWaageVerwenden">
  <ng-container *ngFor="let wiegung of auftragsposition.Wiegungen2">
    <!-- Normale Wiegung oder Leergewicht -->
    <ion-item lines="none" *ngIf="wiegung.Typ !== 2">
      <ion-label position="stacked">{{ wiegung.Bezeichnung }}</ion-label>
      <div class="wiegung-ausgabe" *ngIf="wiegung.Text">
        {{ wiegung.Text }}
      </div>
      <!-- <ion-input inputmode="numeric" type="text" class="input-readonly with-border" [(ngModel)]="wiegung.Text" readonly></ion-input> -->
    </ion-item>

    <!-- Handeingabe -->
    <ion-item lines="none" *ngIf="wiegung.Typ === 2">
      <ion-label position="stacked">{{ wiegung.Bezeichnung }}</ion-label>
      <ion-input
                 inputmode="numeric"
                 type="text"
                 (ionChange)="onGewichtChanged(wiegung)"
                 [(ngModel)]="wiegung.Gewicht"
                 id="wiegung-{{ auftragsposition.PosNr }}-{{ wiegung.Nummer }}-input"
                 (keyup.enter)="app.closeKeyboard($event)" enterkeyhint="done"
                 clearInput required></ion-input>
    </ion-item>

    <ion-item lines="none" *ngIf="wiegung.Typ === 3">
      <ion-label position="stacked">Einheit</ion-label>
      <ion-select placeholder="{{ 'Bitte Einheit auswählen' | translate }}" [(ngModel)]="wiegung.Einheit" (ngModelChange)="onGewichtChanged(wiegung)" interface="popover" required [okText]="'OK' | translate" [cancelText]="'Abbrechen' | translate">
        <ion-select-option *ngFor="let a of einheiten" [value]="a">{{ a }}</ion-select-option>
      </ion-select>
    </ion-item>

    <ng-container *ngIf="!auftragdetails.isLieferungAendernGesperrt">
      <!-- Wiegen-Button -->
      <ion-button size="large" class="auftragsposition-wiegen-button" [color]="getWiegenButtonColor(wiegung.Nummer, 1)" appClick (clicked)="onWiegen(wiegung.Nummer)">
        <ion-icon *ngIf="wiegung.Erfolgreich" slot="start" icon="checkmark" class="icon-checkmark"></ion-icon>
        Wiegen
      </ion-button>

      <!-- Handeingabe -->
      <ion-button *ngIf="wiegenHandeingabeErlaubt" size="large" class="auftragsposition-handeingabe-button item-text-wrap" [color]="getWiegenButtonColor(wiegung.Nummer, 2)" appClick (clicked)="onHandeingabe(wiegung.Nummer)">Hand&shy;eingabe</ion-button>

      <!-- Leergewicht -->
      <ion-button *ngIf="wiegenLeergewichtErlaubt" size="large" class="auftragsposition-leergewicht-button" [color]="getWiegenButtonColor(wiegung.Nummer, 3)" appClick (clicked)="onLeergewicht(wiegung.Nummer)">Leer&shy;gewicht</ion-button>
    </ng-container>
  </ng-container>

  <div *ngIf="auftragsposition.NettoGewicht" class="netto-gewicht">Netto: <span class="netto-gewicht-span" [class.ungueltig]="auftragsposition.NettoGewicht < 0">{{ auftragsposition.NettoGewicht }}</span> {{ auftragsposition.Wiegungen2[0].Einheit }}</div>
</div>

<ion-select #waagenSelect [hidden]="true" (ionChange)="onWaageSelected($event)" [multiple]="false" [okText]="'OK' | translate" [cancelText]="'Abbrechen' | translate" [(ngModel)]="ausgewaehlteWaage" class="waagen-select" interface="action-sheet" mode="ios">
  <ion-label>Waage</ion-label>
  <ion-select-option *ngFor="let w of waagen" [value]="w">{{ w.Name }}</ion-select-option>
</ion-select>

<!-- Auswahl der noch nicht zugeordneten Wiegungen. Mehrfachauswahl per Checkbox, die Nettosumme wird addiert. -->
<ion-select #wiegungenSelect *ngIf="isWiegungZuordnenErlaubt" [hidden]="true" (ionChange)="onWiegungSelected($event)" [multiple]="true" [okText]="'OK' | translate" [cancelText]="'Abbrechen' | translate">
  <ion-label>Wiegungen</ion-label>
  <ion-select-option *ngFor="let w of offeneWiegungen" [value]="w">{{ w.Wiegenummer }}, Net: {{ w.Netto }} kg</ion-select-option>
</ion-select>